import { Box, Flex, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import WizardHeaderLoading from "areas/product/jewlr/loaders/wizard-header-loading"
import { IS_JEWLR } from "helpers/application"

import ProductPrice from "../product-price"

import PromoDesktop from "./promo-desktop"
import RatingsFinancing from "./rating-financing"
import Title from "./title"

const InternalHeaderDesktop = ({ wizardLoading }) => (
  <MediaBox greaterThanOrEqual="tablet">
    <PromoDesktop />
    {!wizardLoading ? (
      <>
        <Flex
          alignItems="stretch"
          gap={1}
          justifyContent="space-between"
          mb={1}
        >
          <Flex flex="1 0 0" flexDirection="column">
            <Title />
          </Flex>
          <Box maxWidth="275px">
            <ProductPrice />
          </Box>
        </Flex>
        {IS_JEWLR() && <RatingsFinancing />}
      </>
    ) : (
      <Box width="100%">
        <WizardHeaderLoading />
      </Box>
    )}
  </MediaBox>
)

InternalHeaderDesktop.propTypes = {
  wizardLoading: PropTypes.string,
}

const mapDispatchToProps = (state) => {
  return {
    wizardLoading: state.wizard.loading,
  }
}

const HeaderDesktop = connect(mapDispatchToProps, {})(InternalHeaderDesktop)

export default HeaderDesktop
